module.exports = __webpack_public_path__ + "img/photo-user-1.4cc54528.svg";